import { observable, flow, action } from 'mobx'
import { feedSubscriptionsApi } from 'api'
import { CommonStore } from 'stores/common'

const FeedSubscriptionsStore = () => {
  /**
   * finds all of the things the user is subcribed to
   */
  const find = flow(function* (userId, params = {}) {
    try {
      this.isLoading = true
      const items = yield this.api.find(userId, params)
      this.items = items
      return items
    } finally {
      this.isLoading = false
    }
  })

  /**
   * gathers the options of things the user could subscribe to
   */
  const findChoices = flow(function* (params = {}) {
    try {
      this.choicesLoading = true
      const choices = yield this.api.findChoices(params)
      this.suggested = choices.filter((choice) => choice.is_suggested)
      this.authors = choices.filter((choice) => choice.type === 'author')
      this.brands = choices.filter((choice) => choice.type === 'brand')
    } finally {
      this.choicesLoading = false
    }
    return {
      suggested: this.suggested,
      authors: this.authors,
      brands: this.brands
    }
  })

  /**
   * creates a subscription or "subscribes the user to something"
   */
  const create = flow(function* (options = {}) {
    const newSubscription = yield CommonStore.create(options)
    this.items.push(newSubscription)
    return newSubscription
  })

  /**
   * updates the subscriptions
   */
  const update = flow(function* (data) {
    const { subscriptions } = data
    try {
      this.isUpdating = true
      yield this.api.update(data)
      this.items = subscriptions
      return subscriptions
    } finally {
      this.isUpdating = false
    }
  })

  /**
   * remove a subscription or "unsubscribe"
   */
  const remove = flow(function* (subscriptionId, subscription) {
    yield this.api.remove(subscriptionId)
    const idx = this.items.findIndex((s) => s.type === subscription.type && s.value === subscription.value)
    if (idx >= 0) this.items.splice(idx, 1)
    return this.items
  })

  const reset = action(function* () {
    this.items = []
    this.suggested = []
    this.authors = []
    this.brands = []
    this.isLoading = false
    this.isUpdating = false
    this.isCreating = false
    this.choicesLoading = false
    yield
  })

  return observable({
    ...CommonStore,
    api: feedSubscriptionsApi,
    suggested: [],
    authors: [],
    brands: [],
    choicesLoading: false,
    find,
    findChoices,
    create,
    update,
    remove,
    reset
  })
}

FeedSubscriptionsStore.cacheKey = 'FeedSubscriptionStore'

export default FeedSubscriptionsStore
